var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShotAutoplayManual = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.07031 0H3.05469L5.97656 8.35156L8.89844 0H10.8828L6.77344 11.375H5.17969L1.07031 0ZM0 0H1.97656L2.33594 8.14062V11.375H0V0ZM9.97656 0H11.9609V11.375H9.61719V8.14062L9.97656 0Z",
    fill: "#E5E4EC"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgShotAutoplayManual);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/shot-autoplay-manual.34627aa63a03b99c5fe082b6a988fc2b.svg";